import { MessageToastService } from './../services/common/message-toast.service';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ToastModule } from 'primeng/toast';
import { MessageService, ConfirmationService } from 'primeng/api';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { CalendarModule } from 'primeng/calendar';
import { InputMaskModule } from 'primeng/inputmask';
import { DropdownModule } from 'primeng/dropdown';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ToolbarModule } from 'primeng/toolbar';
import { FieldsetModule } from 'primeng/fieldset';
import { SliderModule } from 'primeng/slider';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { PanelModule } from 'primeng/panel';
import { CardModule } from 'primeng/card';
import { TabViewModule } from 'primeng/tabview';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogModule, DialogService } from 'primeng/dynamicdialog';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ProgressBarModule } from 'primeng/progressbar';
import { MenuModule } from 'primeng/menu';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { TooltipModule } from 'primeng/tooltip';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { KeyFilterModule } from 'primeng/keyfilter';
import { TagModule } from 'primeng/tag';
import { TabMenuModule } from 'primeng/tabmenu';
import { DividerModule } from 'primeng/divider';
import { FileUploadModule } from 'primeng/fileupload';
import { CheckboxModule } from 'primeng/checkbox';
import { InputNumberModule } from 'primeng/inputnumber';
import { PaginatorModule } from 'primeng/paginator';
import { MultiSelectModule } from 'primeng/multiselect';
import { ChipsModule } from 'primeng/chips';
import {ColorPickerModule} from 'primeng/colorpicker';
import { StepsModule } from 'primeng/steps';
import { EditorModule } from 'primeng/editor';
import {SplitButtonModule} from 'primeng/splitbutton';
import { MenubarModule } from 'primeng/menubar';
import { PasswordModule } from 'primeng/password';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { FormsModule } from '@angular/forms';
import { ListboxModule } from 'primeng/listbox';
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
  ],
  exports: [
    ListboxModule,
    InputTextModule,
    PasswordModule,
    ButtonModule,
    ProgressBarModule,
    ToastModule,
    TagModule,
    TabMenuModule,
    InputTextareaModule,
    ConfirmDialogModule,
    ProgressSpinnerModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    CalendarModule,
    DividerModule,
    InputMaskModule,
    DropdownModule,
    AutoCompleteModule,
    TriStateCheckboxModule,
    InputSwitchModule,
    ToolbarModule,
    FieldsetModule,
    SliderModule,
    ToggleButtonModule,
    PanelModule,
    CardModule,
    TabViewModule,
    DialogModule,
    DynamicDialogModule,
    SelectButtonModule,
    SplitButtonModule,
    ProgressBarModule,
    MessagesModule,
    MessageModule,
    MenuModule,
    TooltipModule,
    ScrollPanelModule,
    KeyFilterModule,
    FileUploadModule,
    CheckboxModule,
    InputNumberModule,
    PaginatorModule,
    MultiSelectModule,
    ChipsModule,
    ColorPickerModule,
    StepsModule,
    EditorModule,
    MenubarModule,
    InputGroupModule,
    InputGroupAddonModule,
    FormsModule
  ]
})
export class PrimengModule {
  static forRoot(): ModuleWithProviders<PrimengModule> {
    return {
      ngModule: PrimengModule,
      providers: [
        MessageService,
        ConfirmationService,
        DialogService,
        MessageToastService
      ]
    };
  }
}
